import { useState } from 'react';

export default function Testimonios() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      text: 'Implementar el Agente Inteligente fue la mejor decisión para nuestro negocio. Hemos reducido los tiempos de respuesta en un 90% y nuestros clientes están más satisfechos que nunca. La tecnología es impresionante y la integración fue muy sencilla.',
      name: 'María González',
      position: 'Directora de Operaciones',
      company: 'TechRetail Solutions',
      avatar: 'https://public.readdy.ai/ai/img_res/4df6aa7738b2d3817709ddfe09bf1bae.jpg'
    },
    {
      text: 'La capacidad del agente para entender el contexto y las emociones de nuestros clientes es sorprendente. Hemos visto un aumento del 45% en la satisfacción del cliente y una reducción significativa en la carga de trabajo de nuestro equipo de soporte.',
      name: 'Carlos Ramírez',
      position: 'CEO',
      company: 'InnovaServicios',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20portrait%20with%20friendly%20expression%20in%20modern%20corporate%20environment%20with%20clean%20simple%20background&width=100&height=100&seq=test2&orientation=squarish'
    },
    {
      text: 'Increíble cómo esta tecnología ha transformado nuestra atención al cliente. Disponibilidad 24/7, respuestas precisas y una experiencia que nuestros clientes adoran. La inversión se pagó sola en menos de 3 meses.',
      name: 'Ana Martínez',
      position: 'Gerente de Experiencia del Cliente',
      company: 'GlobalCommerce',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20portrait%20with%20warm%20smile%20in%20contemporary%20office%20space%20with%20clean%20simple%20background&width=100&height=100&seq=test3&orientation=squarish'
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonios" className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-[#1a1f3a] to-[#0a0e27] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, cyan 2px, cyan 4px)',
          backgroundSize: '100% 40px'
        }}></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 sm:mb-8">
            Lo Que Dicen
            <br />
            <span className="bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
              Nuestros Clientes
            </span>
          </h2>
          
          <div className="flex items-center justify-center gap-1 sm:gap-2 mb-3 sm:mb-4">
            {[...Array(5)].map((_, i) => (
              <i key={i} className="ri-star-fill text-2xl sm:text-3xl text-yellow-400"></i>
            ))}
          </div>
          <div className="text-3xl sm:text-4xl font-bold text-white">4.9/5.0</div>
        </div>

        <div className="relative">
          <div className="bg-gradient-to-br from-[#1a1f3a]/80 to-[#0a0e27]/80 backdrop-blur-lg rounded-3xl p-6 sm:p-8 md:p-12 border border-cyan-500/20 shadow-2xl shadow-cyan-500/10">
            <i className="ri-double-quotes-l text-4xl sm:text-5xl md:text-6xl text-cyan-400 opacity-30 mb-4 sm:mb-6"></i>
            
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white leading-relaxed mb-8 sm:mb-12 min-h-[160px] sm:min-h-[200px]">
              {testimonials[currentIndex].text}
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full overflow-hidden border-2 border-cyan-400 shadow-lg shadow-cyan-500/50 flex-shrink-0">
                  <img 
                    src={testimonials[currentIndex].avatar} 
                    alt={testimonials[currentIndex].name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="text-base sm:text-lg font-bold text-white">{testimonials[currentIndex].name}</div>
                  <div className="text-sm sm:text-base text-gray-400">{testimonials[currentIndex].position}</div>
                  <div className="text-cyan-400 text-xs sm:text-sm">{testimonials[currentIndex].company}</div>
                </div>
              </div>

              <div className="flex gap-2 sm:gap-3 self-end sm:self-auto">
                <button 
                  onClick={prevTestimonial}
                  className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg border-2 border-white/30 text-white hover:bg-white/10 transition-all duration-300 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-arrow-left-line text-lg sm:text-xl"></i>
                </button>
                <button 
                  onClick={nextTestimonial}
                  className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-cyan-500 text-white hover:bg-cyan-600 transition-all duration-300 flex items-center justify-center shadow-lg shadow-cyan-500/50 cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="flex justify-center gap-2 sm:gap-3 mt-6 sm:mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`transition-all duration-300 rounded-full cursor-pointer ${
                  index === currentIndex 
                    ? 'w-8 sm:w-12 h-2 sm:h-3 bg-cyan-400 shadow-lg shadow-cyan-400/50' 
                    : 'w-2 sm:w-3 h-2 sm:h-3 bg-gray-600 hover:bg-gray-500'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
